<template>
    <!--<div>
      <div class="grid-row">
      <div>
        <div class="c_019" ontouchstart="">
          <fieldset>
            <div class="checkbox section">
              <div class="form-group" style="margin:50px 0px 25px 0px">
                <p>{{$store.state.texts.gdpr.types.eNews.title}}</p>
              </div>
              <div class="form-group">
                <div class="col-8 required" style="position:relative;">
                  <p style="font-size:15px;" for="e-posta-notice" class="nakup-label" v-if="!$store.state.buttons.emailNotice.error && !$store.state.submitted || $store.state.buttons.emailNotice.error">{{$store.state.texts.gdpr.emailNotice.description}}</p>
                  <p style="font-size:15px;" for="e-posta-notice" class="nakup-label marg-bott-none" v-if="!$store.state.buttons.emailNotice.error && $store.state.submitted">{{$store.state.texts.gdpr.emailNotice.description}}</p>
                  <span class="error-message" v-html="$store.state.texts.gdpr.emailNotice.error" v-if="!$store.state.buttons.emailNotice.error && $store.state.submitted"></span>
                </div>
                <div class="form-check form-check-inline col-2 checkbox-margin">
                  <label class="form-check-label" for="e-posta-notice-yes">{{$store.state.texts.gdpr.emailNotice.yes}}
                  <input class="form-check-input" type="radio" v-model="$store.state.buttons.emailNotice.value" :value="true" name="e-posta-notice" id="e-posta-notice-yes" @change="$store.state.buttons.emailNotice.error = true, $store.state.form.gdpr.emailNotice = true">
                  <span class="gdpr-radio-button" :class="{isInvalid: !$store.state.buttons.emailNotice.error && $store.state.submitted}"></span>
                  </label>
                </div>
                <div class="form-check form-check-inline col-2 checkbox-margin">
                  <label class="form-check-label" for="e-posta-notice-no">{{$store.state.texts.gdpr.emailNotice.no}}
                  <input class="form-check-input" type="radio" v-model="$store.state.buttons.emailNotice.value" :value="false" name="e-posta-notice" id="e-posta-notice-no" @change="$store.state.buttons.emailNotice.error = true, $store.state.form.gdpr.emailNotice = false">
                  <span class="gdpr-radio-button" :class="{isInvalid: !$store.state.buttons.emailNotice.error && $store.state.submitted}"></span>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <div class="col-8" style="position:relative;">
                  <p style="font-size:15px;" for="phone-notice" class="nakup-label">{{$store.state.texts.gdpr.phoneNotice.description}}</p>
                </div>
                <div class="form-check form-check-inline col-2 checkbox-margin">
                  <label class="form-check-label" for="phone-notice-yes">{{$store.state.texts.gdpr.phoneNotice.yes}}
                  <input class="form-check-input" type="radio" v-model="$store.state.buttons.phoneNotice.value" :value="true" name="phone-notice" id="phone-notice-yes" @change="checkPhoneField('phoneYes', $store)">
                  <span class="gdpr-radio-button"></span>
                  </label>
                </div>
                <div class="form-check form-check-inline col-2 checkbox-margin">
                  <label class="form-check-label" for="phone-notice-no">{{$store.state.texts.gdpr.phoneNotice.no}}
                  <input class="form-check-input" type="radio" v-model="$store.state.buttons.phoneNotice.value" :value="false" name="phone-notice" id="phone-notice-no" @change="checkPhoneField('phoneNo', $store)">
                  <span class="gdpr-radio-button"></span>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <div class="col-8" style="position:relative;">
                  <p style="font-size:15px;" for="sms-notice" class="nakup-label">{{$store.state.texts.gdpr.smsNotice.description}}</p>
                </div>
                <div class="form-check form-check-inline col-2 checkbox-margin">
                  <label class="form-check-label" for="sms-notice-yes">{{$store.state.texts.gdpr.smsNotice.yes}}
                  <input class="form-check-input" type="radio" v-model="$store.state.buttons.smsNotice.value" :value="true" name="sms-notice" id="sms-notice-yes" @change="checkPhoneField('smsYes', $store)">
                  <span class="gdpr-radio-button"></span>
                  </label>
                </div>
                <div class="form-check form-check-inline col-2 checkbox-margin">
                  <label class="form-check-label" for="sms-notice-no">{{$store.state.texts.gdpr.smsNotice.no}}
                  <input class="form-check-input" type="radio" v-model="$store.state.buttons.smsNotice.value" :value="false" name="sms-notice" id="sms-notice-no" @change="checkPhoneField('smsNo', $store)">
                  <span class="gdpr-radio-button"></span>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <div class="form-check form-check-inline col-2 checkbox-margin">
                  <label class="form-check-label" for="nakup-yes">{{$store.state.texts.gdpr.comply.yes}}
                  <input class="form-check-input" type="radio" v-model="$store.state.buttons.purchase.value" :value="true" name="nakup" id="nakup-yes" @change="$store.state.buttons.purchase.error = false, $store.state.form.gdpr.purchase = true">
                  <span class="gdpr-radio-button" :class="{isInvalid: $store.state.buttons.purchase.error}"></span>
                  </label>
                </div>
                <div class="form-check form-check-inline col-2 checkbox-margin">
                  <label class="form-check-label" for="nakup-no">{{$store.state.texts.gdpr.comply.no}}
                  <input class="form-check-input" type="radio" v-model="$store.state.buttons.purchase.value" :value="false" name="nakup" id="nakup-no" @change="$store.state.buttons.purchase.error = false, $store.state.form.gdpr.purchase = false">
                  <span class="gdpr-radio-button" :class="{isInvalid: $store.state.buttons.purchase.error}"></span>
                  </label>
                </div>
                <div class="col-8 required" style="position:relative;float:right;">
                  <p style="font-size:15px;" for="nakup" class="nakup-label">{{$store.state.texts.gdpr.types.description}}</p>
                  <span class="error-message" v-html="$store.state.texts.gdpr.types.purchase.error" v-if="$store.state.buttons.purchase.error"></span>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div-->
    <div class="grid-row" style="margin-top:20px;">
      <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true" style="margin-top:20px;">
        <div class="panel panel-default">
          <div class="panel-heading consentDownArrow" style="position:relative;" role="tab" id="headingOne">
            <h4 class="panel-title">
              <a role="button" data-toggle="collapse" v-html="$store.state.texts.gdpr.disclosure.text1Title" @click="$store.state.DisclosureOneOpened = !$store.state.DisclosureOneOpened" data-parent="#accordion" aria-expanded="true" aria-controls="collapseOne">
              </a>
            </h4>
          </div>
          <div v-if="$store.state.DisclosureOneOpened" id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
            <div class="panel-body">
              <p v-html="$store.state.texts.gdpr.disclosure.text1Bullet1"></p> 
              <p v-html="$store.state.texts.gdpr.disclosure.text1Bullet2"></p> 
              <p v-html="$store.state.texts.gdpr.disclosure.text1Bullet3"></p> 
              <p v-html="$store.state.texts.gdpr.disclosure.text1Bullet4"></p> 
              <p v-html="$store.state.texts.gdpr.disclosure.text1Bullet5"></p> 
              <p v-html="$store.state.texts.gdpr.disclosure.text1Bullet6"></p> 
              <p v-html="$store.state.texts.gdpr.disclosure.text1Bullet7"></p> 
              <p v-html="$store.state.texts.gdpr.disclosure.text1Bullet8"></p> 
            </div>
          </div>
        </div>
        <p v-html="$store.state.texts.gdpr.disclosure.textSubtitle"></p>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'

export default {
  methods: {
    checkTypes () {
      if (this.$store.state.buttons.personalizacijaBtn.value === false && this.$store.state.buttons.poprodajniIzdelkiBtn.value === false && this.$store.state.buttons.ponudbeZaNakupBtn.value === false) {
        return true
      } else {
        return false
      }
    },
    checkChannels () {
      if (this.$store.state.form.gdpr.ePosta === true || this.$store.state.form.gdpr.sms === true || this.$store.state.form.gdpr.telefon === true || this.$store.state.form.gdpr.obicajnaPosta === true) {
        return false
      } else {
        return true
      }
    },
    checkPhoneField (button, store) {
      //console.log(button);
      //console.log(store.state);
      if(button === "phoneYes") {
        store.state.buttons.phoneNotice.error = false;
        store.state.form.gdpr.phoneNotice = true;
        store.state.validation.phone = false;
      } 
      if (button === "phoneNo") {
        store.state.buttons.phoneNotice.error = false;
        store.state.form.gdpr.phoneNotice = false;
        if(!store.state.form.gdpr.smsNotice) {
          store.state.validation.phone = true;
        } else {
          store.state.validation.phone = false;
        }
      } 
      if (button === "smsYes") {
        store.state.buttons.smsNotice.error = false;
        store.state.form.gdpr.smsNotice = true;
        store.state.validation.phone = false;
      } 
      if (button === "smsNo") {
        store.state.buttons.smsNotice.error = false;
        store.state.form.gdpr.smsNotice = false;
        if(!store.state.form.gdpr.phoneNotice) {
          store.state.validation.phone = true;
        } else {
          store.state.validation.phone = false;
        }
      }
      return store;
    }
    // checkTypesNo () {
    //   if (this.$store.state.buttons.personalizacijaBtn.value === false && this.$store.state.buttons.poprodajniIzdelkiBtn.value === false && this.$store.state.buttons.ponudbeZaNakupBtn.value === false) {
    //     this.$store.state.buttons.complyBtn.value = false
    //     this.$store.state.buttons.personalizacijaBtn.value = null
    //     this.$store.state.buttons.poprodajniIzdelkiBtn.value = null
    //     this.$store.state.buttons.ponudbeZaNakupBtn.value = null
    //     this.$store.state.form.gdpr.ePosta = false
    //     this.$store.state.form.gdpr.sms = false
    //     this.$store.state.form.gdpr.telefon = false
    //     this.$store.state.form.gdpr.obicajnaPosta = false
    //     $('html, body').animate({
    //       scrollTop: $('#compliance').first().offset().top
    //     }, 600)
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped>
   .checkbox {
  font-size: 15px;
  text-align: left;
  margin-top: 0;
}

.form-group.checkbox {
  margin-top: 0px;
}

.section {
  padding: 10px;
}

.col-3 {
  padding-bottom: 20px;
}
.marg-bott-none {
  margin-bottom: 0;
}

/* CUSTOM RADIO BUTTONS */
  .form-group {
    overflow: hidden;
  }
  .form-check {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .form-check-inline {
    display: inline-block;
  }
  label.form-check-label {
    cursor: pointer;
    margin: 0;
    padding: 0;
    font-size: 16px;
    text-transform: uppercase;
  }
  .form-check input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    max-width: 100%;
    z-index: 2;
  }
  input:disabled ~ label {
    cursor: not-allowed;
  }
  .gdpr-radio-button {
    position: absolute;
    top: 0;
    left: 0;
    height: 23px;
    width: 23px;
    &.isInvalid {
      &:after {
        left: 3px !important;
        top: -2px !important;
      }
    }
  }
  .form-check:hover input ~ .gdpr-radio-button {
    background-color: #ccc;
  }
  .gdpr-radio-button:after {
    content: "X";
    position: absolute;
    display: none;
  }
  .form-check input:checked ~ .gdpr-radio-button:after {
    display: block;
    left: 6px;
    top: 1px;
  }
  .col-2 {
    width: 12%;
    height: auto;
    max-width: 100%;
    @media screen and (max-width: 959px){
      width: 50%;
    }
  }

  .checkbox label::before {
    font-size: 17px;
  }

  .col-8 {
      padding: 0;
    @media screen and (max-width: 959px){
      padding: 0;
    }
  }

  .nakup-label {
    //margin-top: 7px;
    line-height: 15px;
    position: relative;
  }

  //ERROR HANDLING
  .isInvalid {
    border: 2px solid red!important;
  }
  input.isInvalid::placeholder {
    color: red;
  }

  label {
    &.isInvalid {
        border: none!important;
      &::before {
        border: 2px solid red!important;
      }
  }
}
  .error-message {
    display: block;
    color: red;
  }
  .col-8 {
    width: 74%;
    @media screen and (max-width: 959px){
      width: 100%;
    }
  }
  .error-message {
    &::before {
      font-size: 14px;
    }
  }
  .btn-error-message {
    color: red;
    position: relative;
    font-size: 12px;
    top: -15px;
  }
  // CHECKBOX TOP MARGIN
  .checkbox-margin {
    margin-top: 10px;
  }
  .nacin-prejemanja-label {
    margin-top: 0!important;
    padding-left: 15px;
    cursor: pointer;
  }
  // GDPR INFORMATION ICON
  .gdpr-information {
      padding: 5px 5px 5px 10px;
      margin-left: 10px;
      width: 25px;
      height: 25px;
      background-color: #CFC9C4;
      border-radius: 50%;
      color: #fff;
      position: absolute;
      top: -1px;
      z-index: 999;
  }

  // FLOATING INFORMATION
  .floating-info {
      position: absolute;
      padding: 20px 10px;
      border: 1px solid #C3002F;
      border-radius: 20px;
      background-color: #fff;
      z-index: 1000;
      width: 40%;
      height: auto;
        &.nakup {
            top: -125px;
            right: 28%;
            @media only screen and (max-width: 992px) {
                top: -75px;
            }
            @media only screen and (max-width: 768px) {
                top: -75px;
                right: 10%;
                width: 75%;
            }
        }
        &.poprodajni-izdelki {
            top: -175px;
            right: 5%;
            @media only screen and (max-width: 992px) {
                top: -125px;
            }
            @media only screen and (max-width: 768px) {
                top: -125px;
            }
        }
        &.personalizacija {
            top: -325px;
            right: 25%;
            @media only screen and (max-width: 992px) {
                top: -275px;
                width: 50%;
            }
            @media only screen and (max-width: 768px) {
                top: -125px;
            }
        }
  }

    /* Tooltip container */
.tooltip {
  font-family: 'Renault Regular';
    position: relative;
    display: inline-block;
    text-align: center;
    color: #ccc;
    font-size: 14px;
    @media screen and (max-width: 790px){
      font-size: 22px;
      text-align: left;
      margin-top: 10px;
      display: inline-block;
    }
    .tooltiptext {
      font-size: 14px;
      font-family: 'Nissan Regular'
    }
    &::before {
      font-family: icon-Nissan-Global;
      content: "";
      padding-right: 5px;
    }
}

/* Tooltip text */
.tooltip .tooltiptext {
    visibility: hidden;
    width: 300px;
    background-color: #fff;
    border: 1px solid #C3002F;
    color: #000;
    text-align: center;
    padding: 15px;
    text-align: left;
    margin: 10px;
    border-radius: 6px;
    /* Position the tooltip text - see examples below! */
    position: absolute;
    margin-top: -50%;
    z-index: 1;
    @media screen and (max-width: 790px){
      position: fixed;
      top: 10%;
      left: 10%;
      width: 80%;
      margin-top: 0;
    }
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext, .tooltip:focus .tooltiptext {
    visibility: visible;
}

.form-group {
  overflow: visible;
}

.consentDownArrow:after {
    font-family: icon-Nissan-Global;
    content: "\E610";
    top: 50%;
    position: absolute;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    pointer-events: none;
    color: #999;
    border-left: 2px solid #eee;
    padding-left: .7142857143em;
    padding-right: .7142857143em;
    color: #c3002f;
    font-size: 1.1428571429em;
    line-height: 1.6;
    right: 0;
    margin-top: .125em;
  }

  .panel-title > a {
    display: block;
  }
  
  .c_019 .required label::after {
    content: "*";
  }
  .required p::after{
    content: "*";
    color: #c3002f;
  }
  h4 > a {
  font-family: "Nissan Regular", Verdana, Arial, sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/Gdpr.vue